export const OfferData=[
    {
    id:1,
    img:require('../Images/OfferImage/offer1.jpg'),
    heading:"LARGEST INVENTORY",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  {
    id:2,
    img:require('../Images/OfferImage/offer2.jpg'),
    heading:"IN-HOUSE TESTING",
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  {
    id:3,
    img:require('../Images/OfferImage/offer3.jpg'),
    heading:"QUALITY ASSURANCE",
    text:'All our products go through various quality checks from procurement to final delivery.',
    
  },
  {
    id:4,
    img:require('../Images/OfferImage/offer4.jpg'),
    heading:"TIMELY DELIVERY",
    text:'We aim to ensure timely delivery of all the orders within given time and is often an area of focus for process improvement initiatives.',
    
  },
  {
    id:5,
    img:require('../Images/OfferImage/offer5.jpeg'),
    heading:"COMPETITIVE PRICES",
    text:'Obtain the best pricing and secure the most reliable deliveries for High Nickel Alloy',
    
  },
  {
    id:6,
    img:require('../Images/OfferImage/offer6.jpg'),
    heading:"WHAT SPECIAL",
    text:'All Inconel (Alloy 600, 601, 625, 718) & Hastelloy (Alloy c22, C276) Sheet, Plates are available in cut to size',
    
  },
]

export const AboutData=[
  {
  id:1,
 
  heading:"Quality Policy",
  text:'We predetermined by customer oriented policy and quality management system, the main objective of which is to comply with all demands and expectations of our customers and enhance their satisfaction to ensure that each manufactured product conforms to international standards of excellence. Keeping the quality aspect utmost in our mind, we follow a system of quality control as per International Standard.',
},
{
  id:2,

  heading:"SHIPPING GLOBALLY",
  text:'We supply high temperature steel products to Malaysia, Indonesia, Netherlands, California, Italy, UK, Singapore etc',
},
{
  id:3,

  heading:"ISO 9001:2015 CERTIFIED ASSURANCE",
  text:'ISO 9001:2015, European Directive 97/23/EC & Crisil Rated exporter of Nickel Base Alloys in Form of Pipe, Pipe Fittings etc',
  
},

]

export const aboutImgData=[
  {
  id:1,
  img:require('../Images/aboutPageImg/about1.jpg'),
  heading:"LARGEST INVENTORY",
  text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
},
{
  id:2,
  img:require('../Images/aboutPageImg/about2.jpg'),
  heading:"IN-HOUSE TESTING",
  text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
},
{
  id:3,
  img:require('../Images/aboutPageImg/about3.jpg'),
  heading:"QUALITY ASSURANCE",
  text:'All our products go through various quality checks from procurement to final delivery.',
  
},
{
  id:4,
  img:require('../Images/aboutPageImg/about4.jpg'),
  heading:"TIMELY DELIVERY",
  text:'We aim to ensure timely delivery of all the orders within given time and is often an area of focus for process improvement initiatives.',
  
},
{
  id:5,
  img:require('../Images/aboutPageImg/about5.jpg'),
  heading:"COMPETITIVE PRICES",
  text:'Obtain the best pricing and secure the most reliable deliveries for High Nickel Alloy',
  
},
{
  id:6,
  img:require('../Images/aboutPageImg/about6.jpg'),
  heading:"WHAT SPECIAL",
  text:'All Inconel (Alloy 600, 601, 625, 718) & Hastelloy (Alloy c22, C276) Sheet, Plates are available in cut to size',
  
},
]

// import '../Images/carbonSteelmg/img1.jpeg'

export const CarbonImgData=[
  {
  id:1,
  img:require( '../Images/carbonSteelmg/img1.jpeg'),
  heading:"Carbon Steel Cold rolled Sheet",
  text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
},
{
  id:2,
  img:require( '../Images/carbonSteelmg/img2.jpeg'),
  heading:"Carbon steel globe valve",
  text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
},
{
  id:3,
  img:require( '../Images/carbonSteelmg/img3.jpeg'),
  heading:"Carbon steel gate valve",
  text:'All our products go through various quality checks from procurement to final delivery.',
  
},

]
export const WeldingImgData=[
  {
  id:1,
  img:require( '../Images/welding_img/img1.jpg'),
  heading:"Carbon Steel Cold rolled Sheet",
  text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
},
{
  id:2,
  img:require( '../Images/welding_img/img2.jpg'),
  heading:"Carbon steel globe valve",
  text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
},
{
  id:3,
  img:require( '../Images/welding_img/img3.jpeg'),
  heading:"Carbon steel gate valve",
  text:'All our products go through various quality checks from procurement to final delivery.',
  
},
{
  id:4,
  img:require( '../Images/welding_img/img4.jpg'),
  heading:"Carbon steel gate valve",
  text:'All our products go through various quality checks from procurement to final delivery.',
  
},

]

export const MildImgData1=[
  {
  id:1,
  img:require( '../Images/mild_steel/img1.png'),
  heading:"MS ROUND BAR",
  text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
},
{
  id:2,
  img:require( '../Images/mild_steel/img2.png'),
  heading:"MS FLAT BAR",
  text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
},
{
  id:3,
  img:require( '../Images/mild_steel/img3.png'),
  heading:"MS SQUARE BAR ",
  text:'All our products go through various quality checks from procurement to final delivery.',
  
},
{
  id:4,
  img:require( '../Images/mild_steel/img4.png'),
  heading:"MS HEXAGONAL BAR ",
  text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
},
{
  id:5,
  img:require( '../Images/mild_steel/img5.png'),
  heading:"MS PLATE",
  text:'All our products go through various quality checks from procurement to final delivery.',
  
}, {
  id:6,
  img:require( '../Images/mild_steel/img6.png'),
  heading:"MS FORGED BARS",
  text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
},
{
  id:7,
  img:require( '../Images/mild_steel/img7.png'),
  heading:"MS ROLLED BARS ",
  text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
},
{
  id:8,
  img:require( '../Images/mild_steel/img8.png'),
  heading:"MS BRIGHT ROD",
  text:'All our products go through various quality checks from procurement to final delivery.',
  
},

]

export const FastenersImgData=[
  {
  id:1,
  img:require( '../Images/fasteners/img3.jpg'),
  heading:"Air Pollution",
  text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
},
{
  id:2,
  img:require( '../Images/fasteners/img2.jpg'),
  heading:"Chemical Processing",
  text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
},
{
  id:3,
  img:require( '../Images/fasteners/img4.jpg'),
  heading:"Electronics & Semi-Conductors",
  text:'All our products go through various quality checks from procurement to final delivery.',
  
},
{
  id:4,
  img:require( '../Images/fasteners/img5.jpg'),
  heading:"Power Generation",
  text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
},
{
  id:5,
  img:require( '../Images/fasteners/img6.jpg'),
  heading:"Pulp & Paper Mills",
  text:'All our products go through various quality checks from procurement to final delivery.',
  
}, {
  id:6,
  img:require( '../Images/fasteners/img7.jpg'),
  heading:"Water Systems",
  text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
},


]

export const IndustryImgData=[
  {
  id:1,
  img:require( '../Images/fasteners/Aimg.jpg'),
  heading:"Aerospace",
  text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
},
{
  id:2,
  img:require( '../Images/fasteners/Cimg.jpg'),
  heading:"Constructions",
  text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
},
{
  id:3,
  img:require( '../Images/fasteners/OilImg.jpg'),
  heading:"Oil & Gas",
  text:'All our products go through various quality checks from procurement to final delivery.',
  
},
{
  id:4,
  img:require( '../Images/fasteners/Pimg1.jpg'),
  heading:"Power Plants",
  text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
},
{
  id:5,
  img:require( '../Images/fasteners/Rimg.jpg'),
  heading:"Refineries",
  text:'All our products go through various quality checks from procurement to final delivery.',
  
}, {
  id:6,
  img:require( '../Images/fasteners/Simg.jpg'),
  heading:"Sugar",
  text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
},


]
